/**
 * Agent 市场 — 使用真实搜索 API
 */

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { searchAgents, AgentDTO } from '../../api/agent';

const CATEGORIES = [
  { key: 'all', label: '全部' },
  { key: 'lifestyle', label: '生活助手' },
  { key: 'development', label: '开发工具' },
  { key: 'office', label: '办公效率' },
  { key: 'creative', label: '创作灵感' },
  { key: 'marketing', label: '营销增长' },
];

export default function AgentMarketplacePage() {
  const navigate = useNavigate();
  const [agents, setAgents] = useState<AgentDTO[]>([]);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('all');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    searchAgents('', { page: 0, size: 20 })
      .then((res) => setAgents(res.items || []))
      .catch(() => setAgents([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <h1 style={styles.title}>🏪 Agent 市场</h1>
        <p style={styles.subtitle}>发现和安装社区精选的 AI Agent</p>
      </div>

      <input
        style={styles.search}
        placeholder="搜索 Agent..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <div style={styles.cats}>
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            style={{ ...styles.cat, ...(category === c.key ? styles.catActive : {}) }}
            onClick={() => setCategory(c.key)}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>加载中...</div>
      ) : agents.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: '#64748b' }}>暂无可安装的 Agent</div>
      ) : (
        <div style={styles.grid}>
          {agents.map((agent) => (
            <div
              key={agent.agentId}
              style={styles.card}
              onClick={() => navigate(`/simon-cat/agents/${agent.agentId}`)}
            >
              <span style={styles.avatar}>{agent.avatar || '🤖'}</span>
              <h3 style={styles.name}>{agent.name}</h3>
              <p style={styles.desc}>{agent.description || '暂无描述'}</p>
              <div style={styles.footer}>
                <span style={styles.model}>{agent.model || 'default'}</span>
                <button style={styles.installBtn} onClick={(e) => { e.stopPropagation(); navigate(`/simon-cat/agents/${agent.agentId}`); }}>
                  安装
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const styles: Record<string, React.CSSProperties> = {
  page: { maxWidth: 1000, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 14 },
  header: { marginBottom: 4 },
  title: { fontSize: 22, fontWeight: 700, margin: 0 },
  subtitle: { fontSize: 12, color: '#64748b', margin: '4px 0 0' },
  search: {
    width: '100%', padding: '10px 14px', borderRadius: 8,
    border: '1px solid rgba(255,255,255,0.08)', background: 'rgba(255,255,255,0.03)',
    color: '#e2e8f0', fontSize: 13, outline: 'none',
  },
  cats: { display: 'flex', gap: 6, flexWrap: 'wrap' as const },
  cat: {
    padding: '5px 12px', borderRadius: 6, border: '1px solid rgba(255,255,255,0.06)',
    background: 'transparent', color: '#94a3b8', fontSize: 11, cursor: 'pointer',
  },
  catActive: { background: 'rgba(99,102,241,0.12)', border: '1px solid rgba(99,102,241,0.3)', color: '#a5b4fc' },
  grid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 14 },
  card: {
    padding: 16, borderRadius: 12, border: '1px solid rgba(255,255,255,0.06)',
    background: 'rgba(255,255,255,0.025)', cursor: 'pointer', transition: 'all 0.2s',
  },
  avatar: { fontSize: 28, display: 'block', marginBottom: 8 },
  name: { fontSize: 14, fontWeight: 600, margin: '0 0 4px' },
  desc: {
    fontSize: 11, color: '#94a3b8', margin: '0 0 10px',
    display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' as const,
  },
  footer: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  model: { fontSize: 10, fontFamily: 'monospace', color: '#64748b' },
  installBtn: {
    padding: '4px 12px', borderRadius: 6, border: '1px solid #6366f1',
    background: 'rgba(99,102,241,0.12)', color: '#a5b4fc', fontSize: 11, fontWeight: 600, cursor: 'pointer',
  },
};
